import { createFileRoute } from '@tanstack/react-router';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/_layout')({
  component: StaffPortal,
});
